<template>
  <div class="map_layer_tool">
    <div class="layer_tool">
      <div class="tool_bars" v-for="(item, index) in layerList" :key="item.id">
        <div v-if="item.icon == 'zd'" class="tool_bar bar_drop_down" :class="{ active: item.visible }"
          @click="changeVisible(item, index)">
          <el-popover popper-class="drop-down-popper" :offset="15" placement="bottom-end" trigger="hover">
            <div class="drop-down-warp" @click.stop="($event) => $event.stopPropagation">
              <div class="drop-down-panel">
                <div class="panel-header">
                  <span>{{ item.name }}</span>
                </div>
                <div class="panel-body">
                  <div class="check-list-box">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                      @change="handleCheckAllChange">全部</el-checkbox>
                    <el-checkbox-group v-model="checkedType" @change="handleCheckedCitiesChange">
                      <el-checkbox v-for="term in terminalType" :label="term" :key="term">{{
                        term
                        }}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="layer_legend">
                    <div class="legend_item">
                      <div class="color_card" v-for="(item, index) in colors" :key="'c_' + index"
                        :style="{ backgroundColor: item }"></div>
                    </div>
                    <div class="legend_item">
                      <div class="item_threshold" v-for="(item, index) in legend" :key="'l_' + index">
                        {{
                          item
                        }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="reference">
              <SvgIcon :name="item.icon" :color="item.visible ? '#4FA1A4' : '#999'" size="16" />
              <span>{{ item.name }} <i class="el-icon-arrow-down drop-down-icon"></i></span>
            </div>
          </el-popover>
        </div>
        <div v-else class="tool_bar" :class="{ active: item.visible }" @click="changeVisible(item, index)">
          <SvgIcon :name="item.icon" :color="item.visible ? '#4FA1A4' : '#999'" size="16" />
          <span>{{ item.name }}</span>
        </div>
        <el-divider direction="vertical" v-if="index < layerList.length - 1"></el-divider>
      </div>
    </div>
  </div>
</template>
<script>
const selectedTerminal = ['第一终端', '第二终端', '第三终端']
export default {
  props: {
    colorRang: Array
  },
  data() {
    return {
      layerList: [],
      showDropDownPanel: false,
      checkAll: true,
      checkedType: selectedTerminal,
      terminalType: selectedTerminal,
      isIndeterminate: false,
      colors: ['#E0F2F2', '#DCEAEB', '#B8D7D8', '#81BBBD', '#4FA1A4', '#137174']
    }
  },
  computed: {
    legend() {
      return this.colorRang
    }
  },
  created() {
    this.layerList = [
      {
        id: 1,
        name: '服务人员数量',
        visible: true,
        icon: 'ry'
      }, {
        id: 2,
        name: '终端数量',
        visible: true,
        icon: 'zd'
      }, {
        id: 3,
        name: '渠道数量',
        visible: false,
        icon: 'qd'
      }
    ]
  },
  mounted() {
    this.$emit('setLayer', { list: this.layerList, terminal: this.checkedType }, true)
  },
  methods: {
    changeVisible(row, i) {
      this.layerList[i].visible = !this.layerList[i].visible
      this.$emit('setLayer', { list: this.layerList, terminal: this.checkedType, target: row.id })
    },
    handleCheckAllChange(val) {
      this.checkedType = val ? selectedTerminal : [];
      this.isIndeterminate = false;
      this.layerList[1].visible = val
      this.$emit('setLayer', { list: this.layerList, terminal: this.checkedType, target: 2 })
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.terminalType.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.terminalType.length;
      this.layerList[1].visible = value.length > 0 ? true : false
      this.$emit('setLayer', { list: this.layerList, terminal: this.checkedType, target: 2 })
    },
  }
}
</script>
<style lang="less">
.map_layer_tool {
  position: absolute;
  right: 3rem;

  .layer_tool {
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0px 3px 8px 1px rgb(0 0 0 / 6%);
    border-radius: 2px;

    .tool_bars {
      display: flex;
      align-items: center;

      .tool_bar {
        height: 34px;
        padding: 0 15px;
        color: #212121;
        display: flex;
        align-items: center;
        cursor: pointer;

        .bar_icon {
          width: 16px;
          margin-right: 5px;
        }

        &.bar_drop_down {
          .bar_icon {
            vertical-align: middle;
            margin-top: -3px;
          }
        }

        &.active {
          color: #4FA1A4;
        }

        &.bar_drop_down {
          position: relative;

          .drop-down-warp {
            padding-top: 0;
            position: absolute;
            top: 34px;
            right: 0;
            transition: all .3s;
          }

          .drop-down-panel {
            width: 400px;
            padding: 15px;
            background: #fff;
            box-shadow: 0px 4px 10px 0px rgb(0 0 0 / 20%);
            color: #212121;
            overflow: hidden;
            display: none;

            .panel-header {
              display: flex;
              justify-content: space-between;
              color: #212121;
              margin-bottom: 10px;
            }

            .panel-body {
              .check-list-box {
                display: flex;
                margin-bottom: 10px;

                label.el-checkbox {
                  margin-right: 15px;
                }

                .el-checkbox__input.is-indeterminate .el-checkbox__inner,
                .el-checkbox__input.is-checked .el-checkbox__inner {
                  background-color: #4FA1A4;
                  border-color: #4FA1A4;
                }

                .el-checkbox__input.is-checked+.el-checkbox__label {
                  color: #4FA1A4;
                }
              }

              .layer_legend {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: center;
                font-size: 12px;

                .legend_item {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  cursor: default;

                  .color_card {
                    width: 16.67%;
                    height: 12px;
                    margin-bottom: 5px;
                  }

                  &+.legend_item {
                    margin: 0 -10px;
                    width: calc(100% + 20px);
                  }
                }
              }
            }
          }

          &:hover {
            .drop-down-warp {
              padding-top: 10px;
            }

            .drop-down-panel {
              display: block;
            }
          }
        }

      }
    }
  }
}
</style>
